/**
 * Одна карточка How development happens. Тексты — config/process.js.
 */

const NUMBER_STYLE = {
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 700,
    fontSize: "1.85rem",
    lineHeight: "1.2",
    color: "#B8FF65",
};

function ProcessCard({ icon, number, title, text, transform, skipTransition, arrowPath, onArrowClick }) {
    return (
        <div className="how-dev-card" style={{ width: "333px", height: "172px", borderRadius: "13px", overflow: "hidden", position: "absolute", top: 0, left: 0, willChange: "transform", transition: skipTransition ? "none" : "transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)", transform }}>
            <div className="how-dev-card-scale" style={{ position: "absolute", top: 0, left: 0, width: "516px", height: "267px", transform: "scale(0.645)", transformOrigin: "top left" }}>
                <div className="how-dev-card-body" style={{
                    position: "absolute", top: 0, left: 0, width: "516px", height: "267px",
                    background: "#272727", borderRadius: "20px",
                }}>
                    <div className="how-dev-card-copy" style={{ position: "absolute", top: "30px", left: "30px", display: "flex", flexDirection: "column", gap: "8px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {icon}
                            <span style={NUMBER_STYLE}>{number}</span>
                        </div>
                        <span style={NUMBER_STYLE}>{title}</span>
                        <p className="how-dev-card-text" style={{ margin: 0, width: "456px", fontFamily: "'Montserrat', sans-serif", fontStyle: "normal", fontWeight: 700, fontSize: "15px", lineHeight: "18px", color: "#FFFFFF" }}>
                            {text}
                        </p>
                    </div>
                    <svg onMouseDown={e => e.stopPropagation()} onClick={onArrowClick} className="how-dev-card-arrow" style={{ position: "absolute", bottom: "24px", right: "24px", cursor: "pointer" }} width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d={arrowPath} stroke="#B8FF65" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>
        </div>
    );
}

export default ProcessCard;
// components/ProcessCard/ProcessCard.js
